function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { sortBy } from 'lodash';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import './panel-estados.scss';
var PanelEstadosComponentCtrl = /*#__PURE__*/function () {
  PanelEstadosComponentCtrl.$inject = ["$log", "NotifService", "AccesoDatos"];
  function PanelEstadosComponentCtrl($log, NotifService, AccesoDatos) {
    _classCallCheck(this, PanelEstadosComponentCtrl);
    _defineProperty(this, "list", []);
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(PanelEstadosComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.$log.info('[PanelEstadosComponentCtrl] onInit');
      this.AccesoDatos.Datos_Client.leerEstadosDoc().then(function (response) {
        return _this.list = sortBy(response.list, function (e) {
          return e.st.orden;
        });
      });
    }
  }, {
    key: "nuevoEstado",
    value: function nuevoEstado() {
      this.list.push({
        estado: '',
        st: {},
        mails: []
      });
    }
  }]);
}();
angular.module('candidato').component('panelEstados', {
  bindings: {},
  controller: PanelEstadosComponentCtrl,
  template: require('./panel-estados.component.html')
  // templateUrl: "panel-estados.component.html",
});